
// import { Link, useNavigate } from "react-router-dom";
// import "./ProductOrder.css";
// import { useParams } from 'react-router';
// //import NavBar from "../../Components/NavBar/NavBar";
// import NavBarSec from "../../Components/NavBarSec/NavBar";
// import SlideCarousel from "../../Components/SlideCarousel/SlideCarousel";
// import Footer from "../../Components/Foooter/Footer";
// import ScrollToTop from "../../Components/Scrolltop/Scrolltop";
// import useContentful from "../../Hooks/Contentful";
// import { useEffect, useState } from "react";
// import { useCart } from "../../Context/CartContext";
// import NavBar from "../../Components/NavBar/NavBar";

// function ProductOrder() {
//   const { getAuthors } = useContentful();
//   const [cardData, setCardData] = useState([]);
//   const [count, setCount] = useState(1);
//   const { addToCart, cartItems } = useCart();
//   const navigate = useNavigate();
//   let { PID } = useParams();

//     const [colors, setColors] = useState([]);
//   const [sizes, setSizes] = useState([]);

 


//   // Mock fetch for colors and sizes
//   const fetchColors = () => {
//     // Simulate fetching from an API
//     return [
//       { id: 'AFB', name: "Red", colorimage: "#ff0000" },
//       { id: 'AFB', name: "Blue", colorimage: "#0000ff" }
//     ];
//   };

//   const fetchSizes = () => {
//     // Simulate fetching from an API
//     return [
//       { id: 'AFB', size: 'S' },
//       { id: 'AFB', size: 'L' }
//     ];
//   };

//     useEffect(() => {
//     getAuthors().then((response) => response && setCardData(response));

//     // Fetch color and size data when component mounts
//     const productColors = fetchColors();
//     setColors(productColors);

//     const productSizes = fetchSizes();
//     setSizes(productSizes);
//   }, []);

// //   import React from 'react';
// // import TikTok from 'react-tiktok';

// // const TikTokEmbed = () => {
// //   return (
// //     <div>
// //       <TikTok url="https://www.tiktok.com/@username/video/1234567890123456789" />
// //     </div>
// //   );
// // };

// // export default TikTokEmbed;


//   const iframe_container = {
//     left: 0,
//               width: "100%",
//               height: 500,
//               position: "relative"
//             }

// const iframe ={top: 0,
// left: 0,
// width: "100%",
// height: "100%",
// position: "absolute",
// border: 0}

//   // const handleAddToCart = (product) => {
//   //   const productToAdd = {
//   //     ...product,
//   //     quantity: count,
//   //     totalPrice: product.price * count,
//   //   };
//   //   addToCart(productToAdd);
//   //   alert(`${count} ${product.title}(s) added to cart Successfully!`);
//   //   setCount(1); // Reset the quantity to 1
//   // };

//   const handleAddToCart = (product) => {
//     const price = Number(product.price); // Ensure price is a number
//     const productToAdd = {
//       ...product,
//       quantity: count,
//       totalPrice: price * count, // Calculate total price
//     };
//     addToCart(productToAdd);
//     alert(`${count} ${product.title}(s) added to cart Successfully!`);
//     setCount(1); // Reset the quantity to 1
//   };
  

//   useEffect(() => {
//     getAuthors().then((response) => response && setCardData(response));
//   }, []);

//   const handleIncrement = (type) => {
//     if (type === "increment") {
//       setCount(count + 1);
//     } else if (type === "decrement" && count > 1) {
//       setCount(count - 1);
//     }
//   };

//   const handleCheckout = () => {
//     navigate("/checkout");
//   };

//   return (
//     <div className="ProductOrderContainer">
//       <ScrollToTop />
//       <div className="NavSecContainerProd">
//         {/* <NavBarSec /> */}
//         <NavBar />
//       </div>

//       <div className="productNavContainer"></div>
//       <div className="minintro">
//         <p>Shop All Pore Eclipse Matte Translucent Setting Powder</p>
//       </div>

//       {cardData &&
//         cardData.map((item, index) => {
//           if (item.id === PID) {
//             return (
//               <div className="ProductDisplay" key={index}>
//                 <div className="ImgVizContainer">
//                   <div className="imgSelf">
//                     <img src={item?.image?.fields?.file?.url} alt={item?.title} />
//                   </div>
//                 </div>

//                 <div className="CardWordingCont">
//                   <div className="wordingSelf">
//                     <div className="VizTitle">
//                       <h2>{item?.title}</h2>
//                     </div>
//                     <div className="VizCategory">
//                       <p>{item?.location}</p>
//                     </div>
//                        {/* Render Colors */}
//                   <div className="productColors">
//                     <h3>Available Colors</h3>
//                     <div className="colorOptions">
//                       {colors.map((color) => (
//                         <div key={color.name} className="colorCircle" style={{ backgroundColor: color.colorimage }}>
//                           <p>{color.name}</p>
//                         </div>
//                       ))}
//                     </div>
//                   </div>

//                   {/* Render Sizes */}
//                   <div className="productSizes">
//                     <h3>Available Sizes</h3>
//                     <div className="sizeOptions">
//                       {sizes.map((size) => (
//                         <button key={size.size} className="sizeButton">{size.size}</button>
//                       ))}
//                     </div>
//                   </div>
//                     <div className="VizIncrementorContainer">
//                       <div className="shopping-basket-button">
//                         <div className="count">
//                           <span className="leftCount" onClick={() => handleIncrement("decrement")}>
//                             -
//                           </span>
//                           {count}
//                           <span className="rightCount" onClick={() => handleIncrement("increment")}>
//                             +
//                           </span>
//                         </div>
//                         <div
//                           className="add-to-bag"
//                           onClick={() => handleAddToCart(item)}
//                         >
//                           <p> Add to Cart</p>
//                         </div>
//                         <div className="price">{`ZMK ${item?.price * count}`}</div>
//                       </div>
//                     </div>
//                     <div className="VizPromotion">
//                       <p>Excluded from promotions.</p>
//                     </div>
//                     <div>
                 
//                       {cartItems?.length > 0 && (
//                         <div className="orderNowCTA">
//                           <button onClick={handleCheckout}>
//                             <h2>Order Now</h2>
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                     <div className="VizDescriptio">
//                       <h2>What it is</h2>
//                       <p>{item?.title}</p>
//                     </div>
//                     <div className="HowtoUse">
//                       <h2>How to Use</h2>
//                       <p>{item?.description}</p>
//                     </div>

//                   <div className="tiktokcover" >
                 
//                   {item?.tiktokvideoid && 

//                               <iframe
//                               src={`https://www.tiktok.com/embed/${item?.tiktokvideoid}`} // Replace with actual video ID
//                               //src={`https://www.tiktok.com/embed/7327927349465451781`} // Replace with actual video ID
//                               // width="325"
//                               // height="575"
//                               frameBorder="0"
//                               allow="autoplay; encrypted-media"
//                               allowFullScreen
//                               ></iframe>
                                                
//                   }
                   
//                 </div>
//                   </div>
//                 </div>
//               </div>
//             );
//           }
//           return null;
//         })}

//       <SlideCarousel Heading={"Related items"} CarouselData={cardData} />
//       <Footer />
//     </div>
//   );
// }

// export default ProductOrder;



// ProductOrder.js
import { Link, useNavigate } from "react-router-dom";
import "./ProductOrder.css";
import { useParams } from 'react-router';
import NavBarSec from "../../Components/NavBarSec/NavBar";
import SlideCarousel from "../../Components/SlideCarousel/SlideCarousel";
import Footer from "../../Components/Foooter/Footer";
import ScrollToTop from "../../Components/Scrolltop/Scrolltop";
import useContentful from "../../Hooks/Contentful";
import { useEffect, useState } from "react";
import { useCart } from "../../Context/CartContext";
import NavBar from "../../Components/NavBar/NavBar";

function ProductOrder() {
  const { getAuthors,getSizes,getColor } = useContentful();
  const [cardData, setCardData] = useState([]);
  const [count, setCount] = useState(1);
  const { addToCart, cartItems } = useCart();
  const navigate = useNavigate();
  let { PID } = useParams();

  const [colors, setColors] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);

  // const fetchColors = () => {
  //   return [
  //     { id: 'AFB', name: "Red", colorimage: "#ff0000", count: 5 },
  //     { id: 'AFB', name: "Blue", colorimage: "#0000ff", count: 3 }
  //   ];
  // };

  // const fetchSizes = () => {
  //   return [
  //     { id: 'AFB', size: 'S', count: 4 },
  //     { id: 'AFB', size: 'L', count: 4 }
  //   ];
  // };

  useEffect(() => {
     getAuthors().then((response) => response && setCardData(response));
     getSizes().then((response) => {
      if (response) {
        setSizes(response);
        setSelectedSize(response[0]);
      }
      getColor().then((response) => {
        if (response) {
          setColors(response);
          setSelectedColor(response[0]);
        }
      });
      
    });
    
    // const productSizes =  getSizes().then((response) => response && setSizes(response) && setSelectedSize("hji"));
    // const productColors =  getColor().then((response) => response && setColors(response) && setSelectedColor(response[0]));
   
    
  //  // const productColors = fetchColors();
  //  if(productColors){
  //    setColors(productColors);
  //    setSelectedColor(productColors[0]);  // Default to first color
  //  }

   // const productSizes = fetchSizes();
  //  if(productSizes){
  //   setSizes(productSizes);
  //   setSelectedSize(productSizes[0]);  // Default to first size
  //  }
  }, []);

  const handleAddToCart = (product) => {
    const price = Number(product.price);
    const productToAdd = {
      ...product,
      quantity: count,
      totalPrice: price * count,
      color: selectedColor.name,
      size: selectedSize.size,
    };
    addToCart(productToAdd);
    alert(`${count} ${product.title}(s) in ${selectedColor.name} - ${selectedSize.size} added to cart successfully!`);
    setCount(1); // Reset the quantity to 1
  };

  const handleIncrement = (type) => {
    // console.log("sizes",selectedColor)
    // console.log("colors",selectedSize,sizes)
    const maxCount = Math.min(selectedColor?.count || 0, selectedSize?.count || 0);

    if (type === "increment" && count < maxCount) {
      setCount(count + 1);
    } else if (type === "decrement" && count > 1) {
      setCount(count - 1);
    } else if (count >= maxCount) {
      alert("You cannot add more items than available in stock!");
    }
  };

  const handleCheckout = () => {
    navigate("/checkout");
  };

  return (
    <div className="ProductOrderContainer">
      <ScrollToTop />
      <div className="NavSecContainerProd">
        <NavBar />
      </div>

      <div className="productNavContainer"></div>
      <div className="minintro">
        <p>AlBeauty store</p>
        {/* <p>{item?.title}</p> */}
      </div>

      {cardData &&
        cardData.map((item, index) => {
          if (item.id === PID) {
            return (
              <div className="ProductDisplay" key={index}>
                <div className="ImgVizContainer">
                  <div className="imgSelf">
                    <img src={item?.image?.fields?.file?.url} alt={item?.title} />
                  </div>
                </div>

                <div className="CardWordingCont">
                  <div className="wordingSelf">
                    <div className="VizTitle">
                      <h2>{item?.title}</h2>
                    </div>
                    <div className="VizCategory">
                      <p>{item?.location}</p>
                    </div>

                    {/* Render Colors */}
                    <div className="productColors">
                      <h3>Available Colors</h3>
                      <div className="colorOptions">
                        {colors && colors.map((color,index) => (
                            
                            <>  

                         {color.productid == PID &&

                              <div
                                key={color?.name}
                                className={`colorCircle ${color === selectedColor ? 'selected' : ''}`}
                                style={{ backgroundColor: `#${color?.colorcode}`}}
                                onClick={() => setSelectedColor(color)}
                                >
                                <p>{color.name}</p>
                                </div>
                              }
                        
                            </>
                        
                        ))}
                      </div>
                    </div>

                    {/* Render Sizes */}
                    <div className="productSizes">
                      <h3>Available Sizes</h3>
                      <div className="sizeOptions">
                        {sizes && sizes.map((size) => (
                          <button
                            key={size.size}
                            className={`sizeButton ${size === selectedSize ? 'selected' : ''}`}
                            onClick={() => setSelectedSize(size)}
                          >
                            {size.size}
                          </button>
                        ))}
                      </div>
                    </div>

                    <div className="VizIncrementorContainer">
                      <div className="shopping-basket-button">
                        <div className="count">
                          <span className="leftCount" onClick={() => handleIncrement("decrement")}>
                            -
                          </span>
                          {count}
                          <span className="rightCount" onClick={() => handleIncrement("increment")}>
                            +
                          </span>
                        </div>
                        <div className="add-to-bag" onClick={() => handleAddToCart(item)}>
                          <p> Add to Cart</p>
                        </div>
                        <div className="price">{`ZMK ${item?.price * count}`}</div>
                      </div>
                    </div>
                    <div className="VizPromotion">
                      <p>Excluded from promotions.</p>
                    </div>
                    <div>
                      {cartItems?.length > 0 && (
                        <div className="orderNowCTA">
                          <button onClick={handleCheckout}>
                            <h2>Order Now</h2>
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="VizDescriptio">
                      <h2>What it is</h2>
                      <p>{item?.title}</p>
                    </div>
                    <div className="HowtoUse">
                      <h2>How to Use</h2>
                      <p>{item?.description}</p>
                    </div>

                    <div className="tiktokcover">
                      {item?.tiktokvideoid && (
                        <iframe
                          src={`https://www.tiktok.com/embed/${item?.tiktokvideoid}`}
                          frameBorder="0"
                          allow="autoplay; encrypted-media"
                          allowFullScreen
                        ></iframe>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          }
          return null;
        })}

      <SlideCarousel Heading={"Related items"} CarouselData={cardData} />
      <Footer />
    </div>
  );
}

export default ProductOrder;




// import { Link } from "react-router-dom";
// import "./ProductOrder.css"
// import { useNavigate, useParams } from 'react-router';



// // import img1 from "../Images/Alcon1.jpg"
// // import img1 from "../../Components/Images/Alcon1.jpg"
// // import img2 from "../../Components/Images/Alcon2.jpg"
// // import img3 from "../../Components/Images/Alcon7.jpg"

// // import img1 from "../../Components/images/img1.jpg"
// // import img2 from "../../Components/images/img1.jpg"
// // import img3 from "../../Components/images/img1.jpg"
// import NavBar from "../../Components/NavBar/NavBar";
// import NavBarSec from "../../Components/NavBarSec/NavBar";
// // import { useState } from "react";
// import SlideCarousel from "../../Components/SlideCarousel/SlideCarousel";
// // import NavSec from "../../Components/NavSec/NavSec";

// // import useAuth from "../../Hooks/UseAuth";
// // import ScrollToTop from "../../Components/Scrolltop/Scrolltop";

// import Footer from "../../Components/Foooter/Footer";
// import ScrollToTop from "../../Components/Scrolltop/Scrolltop";


// // import NavBar from "../../Components/NavBar/NavBar";


// import useContentful from "../../Hooks/Contentful";
// import { useEffect,useState } from "react";

// // function Listing(){  

 

// function ProductOrder({ handleCart}) {

//   const { getAuthors } = useContentful();

//   useEffect(() => {
//       console.log("Hello")
//    // getAuthors().then((response) => console.log("ressedagt",response));
//     getAuthors().then((response) => response && setCardData(response));
//   },[]);

//   const [cardData, setCardData] = useState()


//   //  const {auth,setAuth} = useAuth()

//     let {PID} = useParams();

//     const [count, setCount] = useState(1);
//     const [Bag, setBag] = useState();
//     const [cart, setCart] = useState([])



//     const handleIncrement = (type) => {
//     //   setCount(count + 1);
//       if (type === 'increment') {
//         setCount(count + 1);
//       } else if (type === 'decrement' && count > 1) {
//         setCount(count - 1);
//       }

//     };

//     let BagItems = [

//     ]

//     const HandleOrder = (item) =>{

         

//     }
  
//     const handleAddToBag = (currentItem) => {
//       console.log(`Added ${count} item(s) to the bag.`);

//       alert(`${count} ${currentItem.title}(s) added to cart Successfully!`);
//       setCount(1)
    
//       setCart((prev) => [
//         ...prev,
//         {
//           Price: currentItem?.price,
//           count: count,
//           Title: currentItem?.title,
//           location: currentItem?.location,

//         },
//       ]);
//       // setCart((prev) => [
//       //   ...prev,
//       //   {
//       //     Price: currentItem?.Price,
//       //     count: count,
//       //     Title: currentItem?.Title,
//       //     location: currentItem?.location,

//       //   },
//       // ]);

//       // setAuth(

//       //   (prev) => [
//       //   ...prev,
//       //   {
//       //     "cart" : cart
//       //   },
//       // ]
//       // );

//       // setAuth((prev) => ({
//       //     ...prev,
//       //     "cart": cart,
//       //   }));



      
    
//       console.log("cart", cart);
//       // console.log("auth", auth);
//     };
    


//     // const cardDatazz = [ 
//     //   { 
//     //      ImgUrl: img1,
//     //      Name: "Snowflake Chartels", 
//     //      Title: "Nike Converse",
//     //      Price: 300,
//     //      location : "Chilanga Post Office, Chilanga, Zambia",
//     //      ID  : 1

   
//     //   },
//     //   { 
//     //      ImgUrl: img1,
//     //      Name: "Zed Watch Guy", 
//     //      Title: "Casio Classic Watch",
//     //      Price: 250,
//     //      location : "Findeco House, Lusaka, Zambia",
//     //      ID  : 2
   
//     //   }, 
//     //    { 
//     //      ImgUrl: img1,
//     //      Name: "Snowflakes Chartel", 
//     //      Title: "Airforce Converse",
//     //      Price: 300,
//     //      location : "Down town mall, Lusaka, Zambia",
//     //      ID  : 3
   
//     //   }, 
//     //    { 
//     //      ImgUrl: img1,
//     //      Name: "Snowflakes Chartel", 
//     //      Title: "Airforce Converse",
//     //      Price: 300,
//     //      location : "Chilanga Post Office, Chilanga, Zambia",
//     //      ID  : 4
   
//     //   }, 
   
   
//     //  ]


//     // const cardData = [ 
//     //   { 
//     //      ImgUrl: img2,
//     //      Name: "Pore eclipse Transulucent Powder", 
//     //      Title: "Powder",
//     //      Price: 300
   
//     //   },
//     //   { 
//     //      ImgUrl: img3,
//     //      Name: "Hidro Grip Primer", 
//     //      Title: "Hydrating primer",
//     //      Price: 250
   
//     //   }, 
//     //    { 
//     //      ImgUrl: img2,
//     //      Name: "Future fluid All Over Liquid Concealer", 
//     //      Title: "Concealer",
//     //      Price: 300
   
//     //   }, 
//     //    { 
//     //      ImgUrl: img3,
//     //      Name: "Lip + Cheek", 
//     //      Title: "Cream blush + Lip colour",
//     //      Price: 300
   
//     //   }, 
   
   
//     //  ]


    

    
    
//   return (

//         <div className="ProductOrderContainer"> 
//              <ScrollToTop/>
//             {/* <ScrollToTop/> */}
//             <div className="NavSecContainerProd">
//                <NavBarSec/>
//             </div>
           
//             <div className="productNavContainer">
//                       {/* <NavBar/> */}
//             </div>    
//             <div className="minintro">

//                 <p>Shop All Pore Eclipse Matte Translucent Setting Powder</p>

//             </div>
//       { cardData && cardData.map((item, index)=>{
//         return(
//             <> 
//             {item.id == PID &&  <div className="ProductDisplay">

                  

//                     <div className="ImgVizContainer">       
//                             <div className="imgSelf">
//                                     <img src={item?.image?.fields?.file?.url} />
//                             </div>

//                     </div>

//                     <div className="CardWordingCont">    
//                         <div className="wordingSelf">
                              
//                             <div className="VizTitle">
//                                     <h2>{item?.title}</h2>
//                             </div>
//                             <div className="VizCategory">
//                                     <p>{item?.location}</p>
//                             </div>
//                             <div className="VizIncrementorContainer">

//                                      <div className="shopping-basket-button">
//                                         <div className="count">
//                                         <span className="leftCount" onClick={() => handleIncrement('decrement')}>-</span>
//                                             {count}
//                                          <span className="rightCount"  onClick={() => handleIncrement('increment')}>+</span>
//                                         </div>
//                                         <div className="add-to-bag" onClick={() => 
//                                              {
//                                               handleAddToBag(item)
//                                               handleCart(item,count)
                                             
//                                              }}>
//                                             <p> Add to Bag</p>   
//                                         </div>
//                                         <div className="price">{` ZMK ${item?.price*count}`}</div>
//                                         </div>

                                
//                             </div>
//                             <div className="VizPromotion">
//                                     <p>Excluded from promotions.</p>
//                             </div>
//                             <div>
//                               {
//                                 !Bag ? <>
//                                  <Link className="linkItems" to={"/Order"}>  

//                                     <div className="orderNowCTA">
                                     

//                                          <button onClick={()=> {
//                                           // handleOrder()
//                                           console.log("bag",cart)
//                                           // console.log("auth cart",auth)
//                                         }
//                                           }><h2>Order Now</h2></button>

                                     
                                        
//                                     </div>
//                                     </Link>
                                    
                                
//                                 </> : ""
//                               }
//                             </div>
//                             <div className="VizDescriptio"> 
//                                     <h2>What it is</h2>
//                                     <p>{item?.title}</p>

//                             </div>
//                             <div className="How to Use">    
                                    
//                                       <h2>How to Use</h2>
//                                       <p>
//                                           {item?.description}
//                                       </p>
                                   
//                                       {/* <p>
//                                       -Slide the mess-free, locking sifter open and tap powder into cap of jar.
// -Swirl brush, puff, or sponge through the powder and tap away excess.
// -Apply after makeup application.
// -Pro Tip: For an extra matte look, pair with Pore Eclipse Mattifying Primer and Pore Eclipse Matte Setting Spray.
//                                       </p>
//                                     */}


//                             </div>
//                         </div> 
                       

//                     </div>

//             </div> 

            
//             }
            
//             </>
//         )
//       })}
           

//             {/* END OF PRODTUCT DISPLAY */}

//             <SlideCarousel 
//                 Heading={"Related items"}

//                 CarouselData = {cardData}
            
//             />

//             <Footer/>
                    

                    
           
                

            
//         </div>
//   );
// }

// export default ProductOrder;






// import { Link } from "react-router-dom";
// import "./ProductOrder.css"



// // import img1 from "../Images/Alcon1.jpg"
// import img1 from "../../Components/Images/Alcon1.jpg"
// import img2 from "../../Components/Images/Alcon2.jpg"
// import img3 from "../../Components/Images/Alcon7.jpg"
// import NavBar from "../../Components/NavBar/NavBar";
// import { useState } from "react";
// import SlideCarousel from "../../Components/SlideCarousel/SlideCarousel";
// import Footer from "../../Components/Foooter/Footer";
// import ScrollToTop from "../../Components/Scrolltop/Scrolltop";


// function ProductOrder({ price }) {

//     const [count, setCount] = useState(1);

//     const handleIncrement = (type) => {
//     //   setCount(count + 1);
//       if (type === 'increment') {
//         setCount(count + 1);
//       } else if (type === 'decrement' && count > 1) {
//         setCount(count - 1);
//       }

//     };
  
//     const handleAddToBag = () => {
//       // Implement the logic to add the item to the shopping bag
//       // This is where you would typically make an API call or update some state
//       console.log(`Added ${count} items to the bag.`);
//     };


//     const cardData = [ 
//         { 
//            ImgUrl: img2,
//            Name: "Pore eclipse Transulucent Powder", 
//            Title: "Powder",
//            Price: 300
     
//         },
//         { 
//            ImgUrl: img3,
//            Name: "Hidro Grip Primer", 
//            Title: "Hydrating primer",
//            Price: 250
     
//         }, 
//          { 
//            ImgUrl: img2,
//            Name: "Future fluid All Over Liquid Concealer", 
//            Title: "Concealer",
//            Price: 300
     
//         }, 
//          { 
//            ImgUrl: img3,
//            Name: "Lip + Cheek", 
//            Title: "Cream blush + Lip colour",
//            Price: 300
     
//         }, 
     
     
//        ]


    

    
    
//   return (

//         <div className="ProductOrderContainer"> 
//             <ScrollToTop/>
//             <div className="productNavContainer">
//                       <NavBar/>
//             </div>    
//             <div className="minintro">

//                 <p>Shop All  Pore Eclipse Matte Translucent Setting Powder</p>

//             </div>

//             <div className="ProductDisplay">

//                     <div className="ImgVizContainer">       
//                             <div className="imgSelf">
//                                     <img src={img1} />
//                             </div>

//                     </div>

//                     <div className="CardWordingCont">    
//                         <div className="wordingSelf">
                              
//                             <div className="VizTitle">
//                                     <h2>Pore Eclipse Matte Translucent Setting Powder</h2>
//                             </div>
//                             <div className="VizCategory">
//                                     <p>translucent setting powder</p>
//                             </div>
//                             <div className="VizIncrementorContainer">

//                                      <div className="shopping-basket-button">
//                                         <div className="count">
//                                         <span className="leftCount" onClick={() => handleIncrement('decrement')}>-</span>
//                                             {count}
//                                          <span className="rightCount"  onClick={() => handleIncrement('increment')}>+</span>
//                                         </div>
//                                         <div className="add-to-bag" onClick={handleAddToBag}>
//                                             Add to Bag
//                                         </div>
//                                         <div className="price">{` ZMK ${200 * count}`}</div>
//                                         </div>

//                                 {/* <button>Add to bag</button> */}
//                             </div>
//                             <div className="VizPromotion">
//                                     <p>Excluded from promotions.</p>
//                             </div>
//                             <div className="VizDescriptio"> 
//                                     <h2>What it is</h2>
//                                     <p>A weightless, talc-free translucent setting powder that controls shine, blurs pores and fine lines, and sets makeup for a smooth matte finish.</p>

//                             </div>
//                             <div className="How to Use">    
                                    
//                                       <h2>How to Use</h2>
//                                       <p>
//                                       -Slide the mess-free, locking sifter open and tap powder into cap of jar.
// -Swirl brush, puff, or sponge through the powder and tap away excess.
// -Apply after makeup application.
// -Pro Tip: For an extra matte look, pair with Pore Eclipse Mattifying Primer and Pore Eclipse Matte Setting Spray.
//                                       </p>
                                   


//                             </div>
//                         </div> 
//                         {/* end of word card */}

//                     </div>

//             </div>

//             <SlideCarousel 
//                 Heading={"Related items"}

//                 CarouselData = {cardData}
            
//             />

//             <Footer/>
                    

                    
           
                

            
//         </div>
//   );
// }

// export default ProductOrder;
